import React, { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { Box, Typography, Alert, Grow } from '@mui/material';
import ClockLoader from '../common/ClockLoader';

const POSCallback = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const [status, setStatus] = useState({ type: 'pending', message: 'Processing callback...' });

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const error = params.get('error') || null;
    const errorDescription = params.get('error_description') || params.get('error_message') || null;
    const code = params.get('code') || null;

    if (error || errorDescription) {
      const msg = errorDescription || error || 'Unknown error from provider';
      setStatus({ type: 'error', message: msg });
      // Auto-redirect to dashboard after 3s
      const t = setTimeout(() => navigate('/dashboard'), 3000);
      return () => clearTimeout(t);
    }

    if (code) {
      // Received auth code — show success and redirect. Backend should exchange code for token.
      setStatus({ type: 'success', message: 'Authorization successful. Redirecting...' });
      const t = setTimeout(() => navigate('/dashboard'), 1500);
      return () => clearTimeout(t);
    }

    // No recognizable params — go back to dashboard
    const t = setTimeout(() => navigate('/dashboard'), 1500);
    return () => clearTimeout(t);
  }, [location.search, navigate]);

  return (
    <Box sx={{ minHeight: '60vh', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
      <Grow in>
        <Box sx={{ textAlign: 'center' }}>
          {status.type === 'pending' && <ClockLoader size={72} />}
          {status.type === 'error' && (
            <Box>
              <Alert severity="error" sx={{ mb: 2, fontWeight: 700 }}>{status.message}</Alert>
              <Typography variant="body2" color="text.secondary">Redirecting to dashboard...</Typography>
            </Box>
          )}
          {status.type === 'success' && (
            <Box>
              <Alert severity="success" sx={{ mb: 2, fontWeight: 700 }}>Connected — finishing setup.</Alert>
              <Typography variant="body2" color="text.secondary">Redirecting to dashboard...</Typography>
            </Box>
          )}
        </Box>
      </Grow>
    </Box>
  );
};

export default POSCallback;
